import AppConfig from '@/AppConfig';

const setupLocationMethods = () => {
  window.dev.i('setupLocationMethods: Setting up location methods');

  window.onLocationRequestRejected = (reason) => {
    window.dev.i('setupLocationMethods: Location request rejected:', reason);
    window.dispatchEvent(
      new CustomEvent(AppConfig.LOCATION_REQUEST_REJECTED_EVENT, {
        detail: reason,
      })
    );
  };

  window.onLocationUpdate = (latitude, longitude) => {
    window.dev.i(
      'setupLocationMethods: Location updated:',
      latitude,
      longitude
    );
    window.dispatchEvent(
      new CustomEvent(AppConfig.LOCATION_UPDATED_EVENT, {
        detail: {
          latitude: latitude,
          longitude: longitude,
        },
      })
    );
  };

  window.dev.i('setupLocationMethods: Location methods setup complete');
};

export default setupLocationMethods;
